module.exports = __webpack_public_path__ + "static/collect.f8124fac.png";